import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  START_CHECKOUT,
  CANCEL_SUBSCRIPTION,
  REACTIVATE_SUBSCRIPTION,
} from './constants';
import {
  startCheckoutSuccess,
  startCheckoutError,
  cancelSubscriptionSuccess,
  cancelSubscriptionError,
  reactivateSubscriptionSuccess,
  reactivateSubscriptionError,
} from './actions';

function* startCheckoutSession(action) {
  try {
    const { userId, priceId, returnTo, planType, program } = action;

    const response = yield call(
      axios.post,
      '/api/stripe/create-checkout-session',
      {
        userId,
        priceId,
        returnTo,
        planType,
        program,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    yield put(startCheckoutSuccess(response.data.url));
    window.location.href = response.data.url;
  } catch (error) {
    const errorMessage =
      error.response?.data?.details ||
      error.response?.data?.error ||
      error.message ||
      'Failed to start checkout session.';
    yield put(startCheckoutError(errorMessage));
  }
}

function* cancelSubscription({ userId }) {
  try {
    const response = yield call(axios.post, '/api/stripe/cancel-subscription', {
      userId,
    });

    yield put(cancelSubscriptionSuccess(response.data.successMessage));
  } catch (error) {
    yield put(
      cancelSubscriptionError(
        error.response?.data?.error || 'Failed to cancel subscription.'
      )
    );
  }
}

function* reactivateSubscription({ userId }) {
  try {
    const res = yield call(() =>
      axios.post('/api/stripe/reactivate-subscription', { userId })
    );

    yield put(reactivateSubscriptionSuccess(res.data.successMessage));
  } catch (error) {
    yield put(
      reactivateSubscriptionError(
        error.response?.data?.error || 'Failed to reactivate subscription.'
      )
    );
  }
}

export default function* stripeSaga() {
  yield takeLatest(START_CHECKOUT, startCheckoutSession);
  yield takeLatest(CANCEL_SUBSCRIPTION, cancelSubscription);
  yield takeLatest(REACTIVATE_SUBSCRIPTION, reactivateSubscription);
}
